module.exports = __webpack_public_path__ + "static/img/wall.dc7e138.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/UST/wall.png
// module id = wsOz
// module chunks = 3